import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "@quest_editor/components/SectionHeader";
import QuestStatusChip from "@quest_editor/components/Chips/QuestStatusChip";
import { QuestStatusValue } from "@quest_editor/constants";
import { type Quest } from "@quest_editor/mocks";
import { formatDate } from "utils/common/formatUtils";

type Props = {
  quests: Quest[];
};

const QuestListSection = ({ quests }: Props) => {
  const { t } = useTranslation("questEditor");

  return (
    <Paper elevation={0} sx={{ border: 1, borderColor: "divider" }}>
      <SectionHeader title={t("promotion_progress.section.quest_list")} />
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{t("promotion_progress.table.header.id")}</TableCell>
              <TableCell>
                {t("promotion_progress.table.header.name")}
              </TableCell>
              <TableCell>
                {t("promotion_progress.table.header.status")}
              </TableCell>
              <TableCell>
                {t("promotion_progress.table.header.progress")}
              </TableCell>
              <TableCell>
                {t("promotion_progress.table.header.schedule")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {quests.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography color="text.secondary" py={4}>
                    {t("common.label.no_data")}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              quests.map((quest) => (
                <TableRow key={quest.id} hover>
                  <TableCell>{quest.id}</TableCell>
                  <TableCell>{quest.name}</TableCell>
                  <TableCell>
                    <QuestStatusChip
                      status={quest.status as QuestStatusValue}
                    />
                  </TableCell>
                  <TableCell>
                    {quest.progress !== null
                      ? `${quest.progress} / ${quest.progressMax}`
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {quest.startAt && quest.endAt
                      ? t("promotion_progress.table.schedule_label", {
                          start: formatDate(quest.startAt),
                          end: formatDate(quest.endAt),
                        })
                      : "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default QuestListSection;
